import { NavbarComponent } from './../components/shared/navbar/navbar.component';
import { ModalComponent } from './../components/modal/modal.component';
//import { componentFactoryName } from '@angular/compiler';
import { ComponentRef, Injectable, ComponentFactoryResolver, ViewContainerRef } from '@angular/core';
import { Subject } from 'rxjs';



@Injectable({
  providedIn: 'root'
})
export class ModalService {
  private componentRef!: ComponentRef<ModalComponent>;
  private componentSubscriber!: Subject<string>;
  constructor(
    private resolver: ComponentFactoryResolver) {}

  usersToRemove: [];

  openModal(entry: ViewContainerRef, modalTitle: string, modalBody: string) {
    let factory = this.resolver.resolveComponentFactory(ModalComponent);
    this.componentRef = entry.createComponent(factory);
    this.componentRef.instance.title = modalTitle;
    this.componentRef.instance.body = modalBody;
    this.componentRef.instance.closeMeEvent.subscribe(() => this.closeModal());
    this.componentRef.instance.confirmEvent.subscribe(() => this.confirm());
    this.componentSubscriber = new Subject<string>();
    return this.componentSubscriber.asObservable();
  }

  closeModal() {
    this.componentRef.destroy();
    this.componentSubscriber.complete();

  }

  confirm() {
    this.componentSubscriber.next('confirm');
    this.closeModal();
  }
}
